<div class="addContainer">
  <div class="modalHeader">
    <div class="editRowModal">
      <div class="modalHeader clearfix">
        <div class="modal-about">
          {{ dialogTitle }}
        </div>
      </div>
    </div>
    <button (click)="dialogRef.close()" aria-label="Close dialog" class="modal-close-button" mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div mat-dialog-content>
    <form (ngSubmit)="submit()" [formGroup]="userTypeForm" class="register-form m-4">

      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>NOMBRE</mat-label>
            <input
              aria-autocomplete="none"
              autocomplete="nope"
              formControlName="nombre" matInput required>
            <mat-icon class="material-icons-outlined color-icon p-3" matSuffix>supervised_user_circle</mat-icon>
          </mat-form-field>
          <div *ngIf="userTypeForm.get('nombre')?.touched && userTypeForm.get('nombre')?.hasError('required')"
               class="custom-error-below">
            <small class="text-danger">NOMBRE OBLIGATORIO.</small>
          </div>
          <div *ngIf="userTypeForm.get('nombre')?.touched && userTypeForm.get('nombre')?.hasError('pattern')"
               class="custom-error-below">
            <small class="text-danger">SOLO LETRAS Y ESPACIOS.</small>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
          <div class="example-button-row">
            <button (click)="confirmAdd()" [disabled]="!userTypeForm.valid" [mat-dialog-close]="1" color="primary"
                    mat-flat-button>GUARDAR
            </button>
            <button (click)="onNoClick()" color="warn" mat-flat-button tabindex="-1">CANCELAR</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
